import { ChevronRight, type LucideIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BoxIcon } from '@/Domain/components/Shared/BoxIcon/BoxIcon';
import { Button } from '@/Domain/components/Shared/Button/Button';

type Props = {
  className?: string;
  icon: LucideIcon;
  titleTranslationKey?: string;
  descriptionTranslationKey?: string;
  buttonTextTranslationKey?: string;
  buttonLink?: string;
  spacing?: 'small' | 'large';
};

export const ChartPlaceholder = ({
  className = '',
  icon: PlaceholderIcon,
  titleTranslationKey,
  descriptionTranslationKey,
  buttonTextTranslationKey,
  buttonLink,
  spacing = 'small',
}: Props) => {
  const { t } = useTranslation('insights_page', { keyPrefix: 'chart_placeholders' });

  const spacingClass = spacing === 'large' ? 'space-y-4' : 'space-y-2';
  const title = titleTranslationKey ? t(titleTranslationKey) : '';
  const description = descriptionTranslationKey ? t(descriptionTranslationKey) : '';
  const buttonText = buttonTextTranslationKey ? t(buttonTextTranslationKey) : '';

  return (
    <div
      className={`flex flex-col items-center justify-center text-center ${spacingClass} py-12 text-sm text-muted-foreground ${className}`}
    >
      <BoxIcon variant="outlined" className="mx-auto">
        <PlaceholderIcon className="size-5 text-muted-foreground" />
      </BoxIcon>
      <div className={spacing === 'large' ? 'space-y-2' : ''}>
        <p className="font-semibold text-foreground">{title}</p>
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
      {buttonText && buttonLink && (
        <Button asChild variant="secondary" size="sm">
          <Link to={buttonLink}>
            {buttonText}
            <ChevronRight className="size-4" />
          </Link>
        </Button>
      )}
    </div>
  );
};
